import React from 'react'
import {Image} from 'semantic-ui-react'
import { Row, Col } from 'react-flexbox-grid'

import Error404 from '../images/404.png'

const NoMatch = () => (
  <Row>
    <Col xs={10} className='lisia-app-logo-wrapper'>
      <div style={{textAlign: 'center',height: '505px' , background: `url(${Error404}) center  no-repeat`,}}/>
    </Col>
  </Row>
  )

export default NoMatch